export default __webpack_public_path__ + "static/media/tagIcon-03.9300f23c.svg";